import React from "react";

import type { BorgContextPin } from "../models/borg-types";

import { formatPinLabel, formatPinTooltip } from "./_format-pin-label";

interface ContextChipProps {
	pin: BorgContextPin;
	onRemove?: () => void;
}

export const ContextChip: React.FC<ContextChipProps> = ({ pin, onRemove }) => (
	<span
		className="inline-flex items-center gap-1 rounded-full border border-grey-400 bg-white px-2.5 py-1 text-grey-800 text-xs shadow-sm"
		title={formatPinTooltip(pin)}
	>
		{formatPinLabel(pin)}
		{onRemove != null && (
			<button
				aria-label="Remove"
				className="cursor-pointer rounded-full text-grey-500 leading-none transition-colors hover:bg-grey-100 hover:text-grey-800"
				onClick={onRemove}
				type="button"
			>
				×
			</button>
		)}
	</span>
);
